import {useEffect, useState} from 'react';
import ReactSelect from "react-select";
import {UseDelete, UsePatch, UsePost, UsePut} from "../../hooks/http";
import {UseLimit, UseOrder} from "../../hooks/settings";
import {UseMessage} from "../../hooks/UseMessage";

import ListingTable from "../../components/listing/listing";
import {UtcDateTimeToDateTime} from "../../hooks/dates";
import Select from "../../components/input/select";
import Button from "../../components/button";
import CardMenu from "../../components/card-menu";
import Menu from "./TopMenu";


const Fields = ({audience}) => {

    const searchColumn = 'name'
    const [isLoading, setIsLoading] = useState(true)
    const [entities, setEntities] = useState([])
    const [totalEntities, setTotalEntities] = useState(0)
    const [currentOffset, setCurrentOffset] = useState(0)
    const [currentLimit, setCurrentLimit] = useState(UseLimit)
    const [currentOrder, setCurrentOrder] = useState(UseOrder)
    const [searchValue, setSearchValue] = useState("")
    const [bulkAction, setBulkAction] = useState()
    const [lastChange, setLastChange] = useState(Date.now())
    const [fieldTarget, setFieldTarget] = useState('audience')
    const AudienceMenu = Menu({audience: audience})


    const targets = [
        {value: 'audience', label: "Audience"},
        {value: 'history', label: "History"},
    ]


    const types = [
        {value: 'alnum', label: "Alnum"},
        {value: 'string', label: "String"},
        {value: 'numeric', label: "Numeric"},
        {value: 'phone', label: "Phone"},
        {value: 'email', label: "Email"},
        {value: 'list_item', label: "List Item"},
        {value: 'datetime', label: "Datetime"},
    ]


    const CustomCheckbox = (props) => {
        const {name, value, handleChange, disabled} = props
        return (<div className="Checkbox justify-content-start">
            <div className="custom-control custom-switch">
                <input name={name} value={value} type="checkbox" disabled={disabled} onChange={handleChange}
                    checked={value === "on"} id={`custom_switch_${name}`} className="custom-control-input"/>
                <label className="custom-control-label" aria-disabled={false} htmlFor={`custom_switch_${name}`}>
                </label>
            </div>
        </div>)
    }


    const CustomText = (props) => {
        const {name, value, className, disabled, onBlur} = props
        const [inputValue, setInputValue] = useState(value)

        const handleChange = (ev) => {
            setInputValue(ev.target.value)
        }

        return <input
            type="text"
            name={name}
            onBlur={onBlur}
            value={inputValue}
            disabled={disabled}
            className={className}
            onChange={handleChange}
            placeholder="A short description"
        />
    }

    const FieldName = ({entity}) => {

        const handleBlur = (ev) => {
            if (entity?.name !== ev.target.value) {
                UsePatch(
                    `/audiences/${audience?._id?.$oid}/fields/${entity?._id?.$oid}/update/${fieldTarget}`,
                    {data: {name: ev.target.value}}
                ).then((response) => {
                    UseMessage(
                        response?.code >= 200 && response?.code <= 299 ? 'success' : 'error',
                        response?.errors?.name ? response.errors.name : response?.message
                    )
                })
            }
        }


        return <CustomText
            onBlur={handleBlur}
            value={entity?.name}
            className="editable-title"
            disabled={!entity?.can_edit_name}
            name={`name_${entity?._id?.$oid}`}
        />
    }


    const FieldRequired = ({entity}) => {
        const required = ["mobile_phone", "email_address"]
        const [value, setValue] = useState(entity?.required)


        const checkDisabled = () => {
            return fieldTarget === "audience" ? required.includes(entity?.name) : entity?.is_system_field
        }

        const handleChange = (ev) => {
            setValue(ev.target.checked ? "on" : "off")

            UsePatch(
                `/audiences/${audience?._id?.$oid}/fields/${entity?._id?.$oid}/update/${fieldTarget}`,
                {data: {required: ev.target.checked ? "on" : "off"}}
            ).then((response) => {
                if (response?.code > 299) {
                    UseMessage("error",
                        response?.errors?.required ? response.errors.required : response?.message
                    )
                }
            })
        }

        return <CustomCheckbox value={value} handleChange={handleChange}
            disabled={checkDisabled()} name={`required_${entity?._id?.$oid}`}
        />
    }


    const FieldType = ({entity}) => {
        const value = types.find(element => element.value === entity?.field_type)
        const [inputValue, setInputValue] = useState(value)

        const handleChange = (selected) => {
            setInputValue(selected)
            if (inputValue !== selected) {
                UsePatch(
                    `/audiences/${audience?._id?.$oid}/fields/${entity?._id?.$oid}/update/${fieldTarget}`,
                    {data: {field_type: selected.value}}
                ).then((response) => {
                    if (response?.code > 299) {
                        UseMessage("error",
                            response?.errors?.field_type ? response.errors.field_type : response?.message
                        )
                    }
                })
            }
        }


        const styles = {
            control: base => ({
                ...base,
                border   : 0,
                boxShadow: "none",
                cursor   : "pointer"
            })
        };


        return <div style={{width: '90px'}}>
            <ReactSelect
                isReady={true}
                styles={styles}
                options={types}
                value={inputValue}
                placeholder="Choose"
                onChange={handleChange}
                classNamePrefix="unstyled"
                name={`type_${entity?._id?.$oid}`}
                isDisabled={!entity?.can_edit_type}
            />
        </div>
    }


    const FieldIndex = ({entity}) => {
        const required = ["mobile_phone", "email_address"]
        const [value, setValue] = useState(entity?.is_filter)

        const handleChange = (ev) => {
            setValue(ev.target.checked ? "on" : "off")

            UsePatch(
                `/audiences/${audience?._id?.$oid}/fields/${entity?._id?.$oid}/update/${fieldTarget}`,
                {data: {is_filter: ev.target.checked ? "on" : "off"}}
            ).then((response) => {
                if (response?.code > 299) {
                    UseMessage("error",
                        response?.errors?.is_filter ? response.errors.is_filter : response?.message
                    )
                }
            })
        }

        const checkDisabled = () => {
            return fieldTarget === "audience" ? required.includes(entity?.name) : entity?.is_system_field
        }

        return <CustomCheckbox value={value} handleChange={handleChange}
            disabled={checkDisabled()} name={`index_${entity?._id?.$oid}`}
        />
    }


    const FieldDescription = ({entity}) => {
        const handleBlur = (ev) => {
            if (entity?.description !== ev.target.value) {
                UsePatch(
                    `/audiences/${audience?._id?.$oid}/fields/${entity?._id?.$oid}/update/${fieldTarget}`,
                    {data: {description: ev.target.value}}
                ).then((response) => {
                    if (response?.code > 299) {
                        UseMessage("error",
                            response?.errors?.description ? response.errors.description : response?.message
                        )
                    }
                })
            }
        }


        return <CustomText
            onBlur={handleBlur}
            className="editable-value"
            value={entity?.description}
            disabled={entity?.is_system_field}
            name={`description_${entity?._id?.$oid}`}
        />
    }


    const handleFieldTarget = (selected) => {
        setFieldTarget(selected)
        setFieldTarget(selected.value)
    }


    const addNewField = () => {
        const now = Date.now()

        UsePost(
            `/audiences/${audience?._id?.$oid}/fields/create`,
            {data: {name: `field_${now}`, field_type: 'string', field_target: fieldTarget}}
        ).then((response) => {
            if (response?.code >= 200 && response?.code < 299) {
                setLastChange(now)
            }
        })

    }


    const fetchEntities = async () => {
        let filters = {
            limit    : currentLimit,
            offset   : currentOffset,
            sortBy   : "created_at",
            sortOrder: currentOrder,
        };

        if (searchValue.trim() !== "") {
            filters["findBy"] = searchColumn;
            filters["findTerm"] = searchValue;
        }


        const request = await UsePut(
            `/audiences/${audience?._id?.$oid}/fields/get/${fieldTarget}`,
            {data: filters}
        );


        setTotalEntities(request.total);
        return request?.entities?.length > 0 ?
            request.entities : [];
    };


    useEffect(() => {
        fetchEntities().then((entities) => {
            setEntities(entities);
            setIsLoading(false);
        });
    }, [currentOffset, currentLimit, searchValue, currentOrder, lastChange, fieldTarget]);


    const handleDelete = async (selected) => {
        if (selected.length === 0) {
            UseMessage("error", "Please choose some items")
        } else {
            await UseDelete(`/audiences/${audience?._id?.$oid}/fields/delete`,
                {
                    data: {idx: selected}, onSuccess: (response) => {
                        setLastChange(Date.now());
                    }
                }
            );


        }
    };


    const ListingOptions = {
        entities      : entities,
        isLoading     : isLoading,
        currentPage   : Math.ceil(currentOffset / currentLimit) + 1,
        totalEntities : totalEntities,
        currentLimit  : currentLimit,
        currentOrder  : currentOrder,
        searchColumn  : searchColumn,
        template      : "table",
        onSearch      : (value) => {
            setCurrentOffset(0);
            setSearchValue(value);
        },
        onCleanSearch : () => {
            setSearchValue("");
        },
        onChangePage  : (page) => {
            setCurrentOffset(currentLimit * (page - 1));
        },
        onChangeLimit : (ev) => {
            UseLimit(setCurrentLimit, ev.target.text);
        },
        onChangeOrder : (ev) => {
            UseOrder(setCurrentOrder, ev.target.text);
        },
        onChangeAction: (action) => {
            setBulkAction(action);
        },
        onClickApply  : (selected) => {
            if (typeof bulkAction == "undefined") {
                UseMessage("error", "Please choose an action")
            } else {
                bulkAction["action"](selected);
            }
        },
        columns       : [
            {
                label: "Name", prop: "field_name", size: 25, output: (entity) => {
                    return <FieldName entity={entity}/>;
                }
            },
            {
                label: "Required", prop: "field_required", output: (entity) => {
                    return <FieldRequired entity={entity}/>
                }
            },
            {
                label: "Field Type", prop: "field_type", output: (entity) => {
                    return <FieldType entity={entity}/>
                }
            },
            {
                label: "Index", size: 25, prop: "field_index", output: (entity) => {
                    return <FieldIndex entity={entity}/>
                }
            },
            {
                label: "Description", size: 25, prop: "field_description", output: (entity) => {
                    return <FieldDescription entity={entity}/>
                }
            },
            {
                label: "Created at", size: 15, prop: "created_at", output: (entity) => {
                    return UtcDateTimeToDateTime(entity?.created_at);
                }
            }
        ],
        filters       : [],
        actions       : [
            {value: "delete", label: "Delete", action: (selected) => handleDelete(selected)}
        ],
        edit          : {
            path : `/audiences/:id`,
            label: "Edit audience",
            icon : "edit"
        },
        addons        : {
            afterCard: <CardMenu {...AudienceMenu}/>,
            top      : {
                left:
                    <div className="d-flex">
                        <div className="me-2">
                            <Button
                                size="sm"
                                icon="plus"
                                color="primary"
                                isReady={!isLoading}
                                onClick={addNewField}
                                style={{height: '32px'}}
                            />
                        </div>
                        <div className="me-2">
                            <Select
                                options={targets}
                                name="field_target"
                                value={fieldTarget}
                                isReady={!isLoading}
                                onChange={handleFieldTarget}
                            />
                        </div>
                    </div>
            }
        }
    };


    return (
        <>
            <ListingTable {...ListingOptions} />
        </>
    )
}

export default Fields;